<template lang="html">
<svg xmlns="http://www.w3.org/2000/svg" width="12.133" height="13.845" viewBox="0 0 12.133 13.845">
  <g id="streamline-icon-design-tool-pencil-ruler_140x140" data-name="streamline-icon-design-tool-pencil-ruler@140x140" transform="translate(0.5 0.5)">
    <path id="Path_44739" data-name="Path 44739" class="cls-1" d="M14.838,22.1h0a1.713,1.713,0,0,1-1.713-1.713v-7.3a1.7,1.7,0,0,1,.181-.766l1.149-2.3a.428.428,0,0,1,.766,0l1.149,2.3a1.7,1.7,0,0,1,.181.766v7.3A1.713,1.713,0,0,1,14.838,22.1Z" transform="translate(-13.125 -9.253)"/>
    <path id="Path_44740" data-name="Path 44740" class="cls-1" d="M13.621,39.375h3.328" transform="translate(-13.572 -35.949)"/>
    <path id="Path_44741" data-name="Path 44741" class="cls-1" d="M13.125,113.75H16.55" transform="translate(-13.125 -103.045)"/>
    <path id="Path_44742" data-name="Path 44742" class="cls-1" d="M74.375,4.375h5.138V17.22H74.375Z" transform="translate(-68.38 -4.375)"/>
    <path id="Path_44743" data-name="Path 44743" class="cls-1" d="M74.375,30.625h1.713" transform="translate(-68.38 -28.056)"/>
    <path id="Path_44744" data-name="Path 44744" class="cls-1" d="M74.375,56.875h1.713" transform="translate(-68.38 -51.737)"/>
    <path id="Path_44745" data-name="Path 44745" class="cls-1" d="M74.375,83.125h1.713" transform="translate(-68.38 -75.418)"/>
    <path id="Path_44746" data-name="Path 44746" class="cls-1" d="M74.375,109.375h1.713" transform="translate(-68.38 -99.099)"/>
  </g>
</svg>

</template>

<script>
export default {
  name: 'IconSalesWordCategory',
};
</script>
<style lang="scss" scoped>
.cls-1 {
    fill: none;
    stroke: #fa0;
    stroke-linecap: round;
    stroke-linejoin: round;
}

</style>


